import styled from "@emotion/styled";
import * as React from "react";
import { Editor, Element } from "slate";
import { useSlate } from "slate-react";

import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";

import { LinkElement } from "../types";

import { LinkButton, LinkButtonGroup } from "./shared";

const ToolbarActionLink = styled.a`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  text-decoration: none;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  width: 250px;

  &:hover {
    text-decoration: underline;
  }

  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & > div {
    padding-bottom: 2px;
    svg {
      fill: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.linkColor
      };
    }
  }

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    p {
      flex-grow: 1;
    }

    & > div {
      flex-basis: 24px;
    }

    width: calc(100vw - 90px);
  }
`;

const LinkToolbar: React.FC<{
  handleEdit: React.EventHandler<React.MouseEvent>;
  handleUnlink: React.EventHandler<React.MouseEvent>;
}> = ({ handleEdit, handleUnlink }) => {
  const editor = useSlate();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [linkEntry] = Editor.nodes(editor, { match: (node: any) => Element.isElement(node) && node.type === "link" });

  if (!linkEntry) {
    return null;
  }

  const [linkNode] = linkEntry;

  return (
    <>
      <ToolbarActionLink
        href={(linkNode as LinkElement).url}
        title={(linkNode as LinkElement).url}
        rel="noopener noreferer"
        target="_blank"
      >
        <p>{(linkNode as LinkElement).url}</p>
      </ToolbarActionLink>
      <LinkButtonGroup>
        <LinkButton size="compact" onMouseDown={handleUnlink}>
          Unlink
        </LinkButton>
        <LinkButton kind="primary" size="compact" onMouseDown={handleEdit}>
          Edit
        </LinkButton>
      </LinkButtonGroup>
    </>
  );
};

export default LinkToolbar;
